module.exports = "app-struct-info-doc-section {\r\n  padding-left: 10px;\r\n}\r\n"